import React from 'react';
import PropTypes from 'prop-types';
import { getParsedDecimal } from '../../../helpers/numberFormatter';
import './PaddedDecimal.css';
var PaddedDecimal = function PaddedDecimal(props) {
  var suffix = props.bemMod && props.bemMod.length ? '--' + props.bemMod : '';
  var parsed = getParsedDecimal(props.value, props.decimals);
  return React.createElement('span', {
    className: 'ap-padded-decimal' + suffix
  }, React.createElement('span', {
    className: 'ap-padded-decimal__units' + suffix
  }, parsed.units), parsed.decimals && React.createElement(React.Fragment, null, React.createElement('span', {
    className: 'ap-padded-decimal__decimal-separator' + suffix
  }, parsed.decimalSeparator), React.createElement('span', {
    className: 'ap-padded-decimal__decimals' + suffix
  }, parsed.decimals), React.createElement('span', {
    className: 'ap-padded-decimal__padding' + suffix
  }, parsed.padding)));
};
PaddedDecimal.propTypes = {
  value: PropTypes.any,
  decimals: PropTypes.number,
  bemMod: PropTypes.string
};
PaddedDecimal.defaultProps = {
  value: 0,
  decimals: 2,
  bemMod: null
};
export default PaddedDecimal;